module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_select_8-66803d132cefebbc343fbdf8c927161f.jpg";